import React from 'react';
import * as R from 'ramda';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
import { FormSectionHeader } from '../../../components/form-section-header';
// forms
import { Fieldset2 } from '../../../forms';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex } from '../../../ui';
//////////////////////////////////////////////////

const servicesFieldSettings = [
  {
    isMulti: true,
    isRequired: true,
    type: 'reactSelect',
    useMenuPortalTarget: true,
    options: 'servicesOptions',
    fieldName: GC.FIELD_SERVICE_GUIDS,
    inputWrapperStyles: { width: '100%' },
    label: ['titles:services', 'Services'],
  },
];

const formEnhance = compose(
  withFormik({
    handleSubmit: ({ serviceGuids }, { props: { submitAction } }) => submitAction(serviceGuids),
    validationSchema: Yup.object().shape({
      [GC.FIELD_SERVICE_GUIDS]: G.yupArrayRequired.max(40, G.getShouldBePickOnlyLocaleTxt(40)),
    }),
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues(
      { [GC.FIELD_SERVICE_GUIDS]: [] },
      initialValues,
    ),
  }),
);

const ServicesForm = formEnhance((props) => {
  const { handleSubmit, servicesOptions } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...G.getFormikProps(props)}
        fields={servicesFieldSettings}
        servicesOptions={servicesOptions}
        fieldsWrapperStyles={{ mt: 15, mb: 20 }}
      />
      <FormFooter />
    </form>
  );
});

const enhance = compose(
  withHandlers({
    handleSetServices: ({ closeModal, setFieldValue }) => (serviceGuids) => {
      setFieldValue(GC.FIELD_SERVICE_GUIDS, serviceGuids);

      if (G.isNotEmpty(serviceGuids)) closeModal();
    },
  }),
  withHandlers({
    handleRemoveServices: ({ handleSetServices }) => () => handleSetServices([]),
    handleOpenServicesForm: (props) => (editMode = false) => {
      const { openModal, serviceGuids, servicesOptions, handleSetServices } = props;

      const initialValues = G.ifElse(G.isTrue(editMode), { serviceGuids }, null);

      const component = (
        <ServicesForm
          initialValues={initialValues}
          submitAction={handleSetServices}
          servicesOptions={servicesOptions}
        />
      );

      const modal = {
        p: 15,
        component,
        options: {
          width: 600,
          height: 'auto',
          maxHeight: '90vh',
        },
      };

      openModal(modal);
    },
  }),
  pure,
);

const iconColor = G.getTheme('colors.dark.blue');

export const ServicesSection = enhance((props) => {
  const { serviceGuids, servicesOptions, handleRemoveServices, handleOpenServicesForm } = props;

  const hasServices = G.isNotNilAndNotEmpty(serviceGuids);
  const optionsMap = R.indexBy(R.prop(GC.FIELD_VALUE), servicesOptions);

  return (
    <FormSectionHeader
      expanded={true}
      title={G.getWindowLocale('titles:services', 'Services')}
      action={G.ifElse(hasServices, null, handleOpenServicesForm)}
    >
      {
        hasServices &&
        <Flex pr={20} width='calc(100% - 50px)'>
          <Flex pl={20} pr={15}>
            <Box mr={15} cursor='pointer' onClick={handleRemoveServices}>
              {I.trash(iconColor)}
            </Box>
            <Box cursor='pointer' onClick={() => handleOpenServicesForm(true)}>
              {I.pencil(iconColor)}
            </Box>
          </Flex>
          <Box py={10} width='100%' wordBreak='break-word'>
            {
              G.createStringFromArray(serviceGuids.map((serviceGuid) => (
                R.pathOr('', [serviceGuid, GC.FIELD_LABEL], optionsMap)
              )), ', ')
            }
          </Box>
        </Flex>
      }
    </FormSectionHeader>
  );
});
